(() => {
  if (window.__abrsmHomepageBundlesRuntime) return;
  window.__abrsmHomepageBundlesRuntime = true;

  const rootSelector = '[data-section-type="abrsm-homepage-bundles"]';

  const route = (path) => {
    let base = '/';
    if (window.Shopify?.routes?.root) base = window.Shopify.routes.root;
    return base.replace(/\/?$/, '/') + path.replace(/^\//, '');
  };

  const setStatus = (root, message) => {
    const status = root?.querySelector('[data-bundle-status]');
    if (status) status.textContent = message || '';
  };

  const refreshCart = () => {
    let drawer = null;

    try {
      if (typeof window.theme?.ensureCartDrawer === 'function') {
        drawer = window.theme.ensureCartDrawer();
      } else if (window.theme?.cartDrawer) {
        drawer = window.theme.cartDrawer;
      }

      if (typeof drawer?.cartForm?.buildCart === 'function') drawer.cartForm.buildCart();

      if (typeof drawer?.open === 'function') {
        drawer.open();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return;
      }
    } catch (error) {
      // Continue through the theme-event fallbacks.
    }

    try {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { source: 'homepage-bundles' } }));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('theme:cart:open'));
    } catch (error) {
      // Continue through the visible cart trigger fallback.
    }

    const trigger = document.querySelector(
      '.js-drawer-open-cart, [data-open-cart], [data-action="open-cart"], button[aria-controls="CartDrawer"]'
    );
    if (trigger) {
      trigger.click();
      return;
    }

    try {
      document.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('theme:cart:open'));
    } catch (error) {
      // No additional cart fallback is available.
    }
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const individualButton = event.target.closest(`${rootSelector} [data-individual-add]`);
    if (individualButton && !individualButton.disabled) {
      const root = individualButton.closest(rootSelector);
      const variantId = Number.parseInt(individualButton.getAttribute('data-variant-id') || '0', 10);
      if (!root || !variantId) return;

      const originalLabel = individualButton.getAttribute('data-label') || individualButton.textContent;
      individualButton.disabled = true;
      individualButton.setAttribute('aria-busy', 'true');
      individualButton.textContent = 'Adding...';
      setStatus(root, 'Adding book to basket.');

      fetch(route('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((payload) => {
              throw payload;
            });
          }
          return response.json();
        })
        .then(() => {
          individualButton.textContent = 'Added';
          setStatus(root, 'Book added to basket.');
          refreshCart();
          window.setTimeout(() => {
            if (individualButton.isConnected) individualButton.textContent = originalLabel;
          }, 1400);
        })
        .catch((error) => {
          const message = error?.description || 'Could not add this book. Please try again.';
          setStatus(root, message);
          individualButton.textContent = originalLabel;
        })
        .finally(() => {
          individualButton.disabled = false;
          individualButton.removeAttribute('aria-busy');
        });
      return;
    }

    const button = event.target.closest(`${rootSelector} [data-bundle-add]`);
    if (!button || button.disabled) return;

    const root = button.closest(rootSelector);
    const card = button.closest('[data-home-bundle]');
    if (!root || !card) return;

    const variantIds = Array.from(card.querySelectorAll('[data-bundle-variant-id]'))
      .map((item) => item.getAttribute('data-bundle-variant-id'))
      .filter(Boolean)
      .filter((id, index, all) => all.indexOf(id) === index);
    const requireAll = card.getAttribute('data-bundle-require-all') === 'true';
    const expectedCount = Number.parseInt(card.getAttribute('data-bundle-expected-count') || '0', 10);

    if (!variantIds.length) {
      setStatus(root, 'No available items to add.');
      return;
    }

    if (requireAll && expectedCount > 0 && variantIds.length !== expectedCount) {
      setStatus(root, 'The complete set is not available right now.');
      return;
    }

    const originalLabel = button.getAttribute('data-label') || button.textContent;
    const discount = (button.getAttribute('data-discount') || '').trim();
    const items = variantIds.map((id) => ({ id: Number.parseInt(id, 10), quantity: 1 }));

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding...';
    setStatus(root, 'Adding bundle to basket.');

    fetch(route('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((payload) => {
            throw payload;
          });
        }
        return response.json();
      })
      .then(() => {
        if (discount) {
          setStatus(root, 'Bundle added. Applying discount at checkout.');
          window.location.assign(route(`discount/${encodeURIComponent(discount)}?redirect=%2Fcart`));
          return;
        }

        button.textContent = 'Added';
        setStatus(root, 'Bundle added to basket.');
        refreshCart();
        window.setTimeout(() => {
          if (button.isConnected) button.textContent = originalLabel;
        }, 1400);
      })
      .catch((error) => {
        const message = error?.description || 'Could not add bundle. Please try again.';
        setStatus(root, message);
        button.textContent = originalLabel;
      })
      .finally(() => {
        if (discount) return;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  });
})();
